import React, { useState } from "react";
import "./header.scss";

import logo from "../../assets/images/logo.svg";
import menuStore from "../../stores/menu_store/menu_store";
import { observer } from "mobx-react-lite";

function Header() {
	const [headerOpen, changeHeaderOpen] = useState<boolean>(false);

	const goTo = (url: string) => (window.location.href = url);

	return (
		<header className="flex header">
			<div className="logo" onClick={() => (window.location.href = "/")}>
				<img src={logo} alt="" />
			</div>

			<ul className={"header_menu flex " + (headerOpen ? "open" : "")}>
				{menuStore.menuItems &&
					menuStore.menuItems.map((item, index) => (
						<li key={index}>
							<span onClick={() => goTo(item[1])}>{item[0]}</span>
						</li>
					))}
			</ul>

			<button
				type="button"
				className={"headerBtnMobil " + (headerOpen ? "active" : "")}
				onClick={() => changeHeaderOpen(!headerOpen)}
			>
				<span></span>
				<span></span>
				<span></span>
			</button>
			<button type="button" className="formSearch__btn"></button>
		</header>
	);
}

export default observer(Header);
